<script>
import AdminLayout from '@layouts/admin-main'
import BalanceList from '@components/admin/affiliate-balance-list'

export default {
  page: {
    title: 'Admin::AffiliateBalanceList',
    meta: [{ name: 'description', content: 'Admin::AffiliateBalanceList' }],
  },
  components: { AdminLayout, BalanceList },
}
</script>

<template>
  <AdminLayout>
    <BalanceList></BalanceList>
  </AdminLayout>
</template>

<style lang="scss" module>
@import '@design';
</style>
